import { inject } from '@angular/core';
import { CanActivateFn, PRIMARY_OUTLET, Router, RouterStateSnapshot } from '@angular/router';
import { ActiveSecurityContextStateService } from './active-security-context.state-service';

/**
 * True when the URL is only the app root (no primary segments), ignoring query/hash.
 */
function navigationTargetIsAppRootOnly(router: Router, state: RouterStateSnapshot): boolean {
  const tree = router.parseUrl(state.url);
  const primary = tree.root.children[PRIMARY_OUTLET];
  return !primary || primary.segments.length === 0;
}

/**
 * When the shell `path: ''` parent matches, redirects **only** navigations to `/`
 * (authenticated) to the same URL as {@link ActiveSecurityContextStateService.redirectToBestRoute}.
 * Other URLs under this parent (`/auth/...`, etc.) pass through.
 */
export const defaultPostLoginRootGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  if (!navigationTargetIsAppRootOnly(router, state)) {
    return true;
  }
  const security = inject(ActiveSecurityContextStateService);
  if (!security.ensureUnityAccess()) {
    return true;
  }
  return router.parseUrl(security.getDefaultPostLoginUrl());
};
